import styles from './Architecture.module.scss'

export const Architecture: React.FC = () => {
  return (
    <div className={styles.architecture_container}>
      <div className={styles.main_container}>
        <div className={styles.top_container}>
          <div className={styles.title_container}>
            <p className={styles.title_red}>Amazon ECS</p>
            <p className={styles.title}>のアーキテクチャ図</p>
          </div>
          <p className={styles.title_text}>一般的なSPAのアーキテクチャ図は以下のようになります。</p>
        </div>
        <img src={'/images/LP/LP202407/AmazonECS/img/Architecture.png'} alt="" className={styles.image} />
      </div>
    </div>
  )
}
